import React from 'react';
import { DaySequenceBinaryProps } from './types';
import { validateDaySequenceBinaryProps } from './validation';
import {
  calculateTotalDays,
  generateDateRange,
  createEventLookupSet,
  calculateDotWidth
} from './utils';
import { DaySequenceBinaryRenderer } from './DaySequenceBinaryRenderer';

export const DaySequenceBinary: React.FC<DaySequenceBinaryProps> = ({
  startDate,
  endDate,
  eventDates,
  color = '#22c55e',
  dotHeight = 20,
  borderRadius = 4,
  showWeekTicks = false,
}) => {

  // Validate props
  const validation = validateDaySequenceBinaryProps({ startDate, endDate, eventDates });
  if (!validation.isValid) {
    throw new Error(validation.error);
  }

  // Calculate total days and generate date range
  const totalDays = calculateTotalDays(startDate, endDate);
  const allDates = generateDateRange(startDate, endDate);
  const eventSet = createEventLookupSet(eventDates);
  const dotWidth = calculateDotWidth(totalDays);

  return (
    <DaySequenceBinaryRenderer
      allDates={allDates}
      eventSet={eventSet}
      totalDays={totalDays}
      dotWidth={dotWidth}
      dotHeight={dotHeight}
      borderRadius={borderRadius}
      showWeekTicks={showWeekTicks}
      color={color}
    />
  );
};